import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=40e6b8a5&scoped=true&"
import script from "./GamePage.vue?vue&type=script&lang=ts&"
export * from "./GamePage.vue?vue&type=script&lang=ts&"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=40e6b8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6b8a5",
  null
  
)

export default component.exports